// extracted by mini-css-extract-plugin
module.exports = {"printStationConfigModal":"PrintStationConfigModal_printStationConfigModal__JnNoI","printStationConfigModalForms":"PrintStationConfigModal_printStationConfigModalForms__1wHJC"};